import { ProductCardLayoutType } from '@eti/components';

// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { constants } from '@eti/utils';
import { ceil } from 'lodash';
export const PRODUCT_ITEM_CATEGORY = {
  MAIN: 'main',
  EXTRA: 'extra'
};
export const ELEMENT_PLACEMENT = {
  ON_PAGE: 'OnPage',
  POP_UP: 'PopUp'
};
export const ELEMENT_ATTRIBUTE = {
  SMALL_CARD: 'SmallCard',
  REGULAR_CARD: 'RegularCard'
};
export const SINGLE_CHOICE_BUTTON = {
  ADD_TO_CART_BUTTON: 'AddToCartButton',
  TOGGLE_BAR_BUTTON: 'ToggleBarButton'
};
export const PRODUCT_BRAND = 'ETG ancillary';
export const getElementAttribute = layoutType => ProductCardLayoutType.Small === layoutType ? ELEMENT_ATTRIBUTE.SMALL_CARD : ELEMENT_ATTRIBUTE.REGULAR_CARD;
export const getSingleChoiceButtonType = shouldEnableAddToCartButton => shouldEnableAddToCartButton ? SINGLE_CHOICE_BUTTON.ADD_TO_CART_BUTTON : SINGLE_CHOICE_BUTTON.TOGGLE_BAR_BUTTON;
const SECONDARY_SECTION_TEST_ID = 'wizard-secondary-section';
const isSecondaryProductsPage = () => Boolean(document.querySelector(`[data-testid="${SECONDARY_SECTION_TEST_ID}"]`));
const getPageSection = path => {
  if (path === '/traveler-details') {
    return isSecondaryProductsPage() ? 'ExtraServices' : 'TravelerDetails';
  }
  return {
    '/result': 'Results',
    '/postbooking/products': 'PostBooking',
    '/order-details/extra-products': 'OrderDetails',
    '/your-selected-trip': 'YourSelectedTrip'
  }[path];
};
const getTitleFromPath = path => {
  let title = getPageSection(path);
  if (title) {
    return title;
  }
  // Remove all slashes and hyphens with space
  title = path.replace(/[/-]/g, ' ').trim();
  // Capitalize the first letter of each word
  return title.replace(/\b\w/g, char => char.toUpperCase());
};
const PRODUCT_SUB_CATEGORY = {
  bankruptcyInsuranceCoverGenius: 'Insurance',
  cancellationInsuranceCoverGenius: 'Insurance',
  comprehensiveInsuranceCoverGenius: 'Insurance',
  travelInsuranceCoverGenius: 'Insurance',
  baggageInsuranceCoverGenius: 'Insurance',
  travelInsuranceInsideEu: 'Insurance',
  travelInsuranceOutsideEu: 'Insurance',
  cancellationInsideEu: 'Insurance',
  cancellationOutsideEu: 'Insurance',
  cancellationGuarantee: 'Cancellation',
  cancelForAnyReason: 'Flexibility',
  cancelTwentyFourHours: 'Flexibility',
  flexibleTicket: 'Flexibility',
  baggageService: 'Insurance',
  seatMap: 'Seating',
  cabinUpgrade: 'Seating',
  platinum: 'Support',
  fastTrack: 'Service',
  lounge: 'Service',
  airportTransfer: 'Service',
  onlineCheckIn: 'CheckIn',
  meal: 'Meal',
  simpleVisa: 'Visa',
  sms: 'Service',
  mobileTravelPlan: 'Service',
  co2Compensation: 'Climate',
  airHelp: 'Insurance'
};
export const getItemCategory2 = productName => PRODUCT_SUB_CATEGORY[productName];
export const getTravelersWithoutInfants = travelers => {
  var _travelers$filter$len;
  return (_travelers$filter$len = travelers === null || travelers === void 0 ? void 0 : travelers.filter(({
    ageType
  }) => ageType !== constants.ageTypes.INFANT).length) !== null && _travelers$filter$len !== void 0 ? _travelers$filter$len : 0;
};
const getFormattedPrice = (priceRaw, exponent) => {
  return priceRaw / 10 ** exponent;
};
export const buildProductGAEvent = (event, input, context) => {
  const {
    productId,
    productCode,
    productName,
    priceRaw,
    quantity,
    index,
    itemCategory = PRODUCT_ITEM_CATEGORY.EXTRA,
    layoutType,
    shouldEnableAddToCartButton,
    itemBrand = PRODUCT_BRAND,
    elementPlacement
  } = input;
  const {
    siteCurrency,
    pathname
  } = context;
  const section = getTitleFromPath(pathname);
  const price = getFormattedPrice(priceRaw, siteCurrency === null || siteCurrency === void 0 ? void 0 : siteCurrency.exponent);
  return {
    event,
    ecommerce: {
      currency: siteCurrency === null || siteCurrency === void 0 ? void 0 : siteCurrency.code,
      value: price,
      items: [{
        item_id: productId,
        item_name: productCode,
        index,
        item_brand: itemBrand,
        item_category: itemCategory,
        item_category2: getItemCategory2(productName),
        item_category3: getSingleChoiceButtonType(shouldEnableAddToCartButton),
        price: ceil(price / quantity, 2),
        quantity,
        section,
        element_placement: elementPlacement !== null && elementPlacement !== void 0 ? elementPlacement : ELEMENT_PLACEMENT.ON_PAGE,
        element_attribute: getElementAttribute(layoutType)
      }]
    }
  };
};
//# sourceMappingURL=productGATrackingUtil.js.map